import React from 'react';
import {createMenuContext} from './ContextMenuContext';
import {FileData} from 'types';
import {useBuildContextMenu} from './useBuildContextMenu';

export const fileMenuContext = createMenuContext<FileData>();

export function useFileMenuContext() {
   return React.useContext(fileMenuContext);
}

export const FileMenuContextProvider = ({children}: {children: React.ReactNode}) => {
   const {Provider} = fileMenuContext;
   const {contextValue} = useBuildContextMenu<FileData>();
   return <Provider value={contextValue}>{children}</Provider>;
};
